var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDots = function SvgDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M10 8.438a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25M14.688 16.563a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25M5.313 16.563a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25"
  })));
};
export default SvgDots;